<template>
	<div :class="[$style.homewrapper]">
		<router-view />
	</div>
</template>

<script setup>
	const version = import.meta.env.VITE_APP_VERSION;
	console.log("%c -----> 001 window.wxInfo", "font-size:13px; background:pink; color:#bf2c9f;", window.wxInfo);
</script>

<style lang="scss" module>
	.homewrapper {
		position: relative;
		width: 100%;
	}
</style>
